import { useAxios } from "@/hooks/useAxios";
import { API_POSTCODE } from "@/types/endpoint";

interface IUpload {
  postcode: string;
}

interface IDownload {
  status: string | null;
  message: string | null;
  results: {
    address1: string;
    address2: string;
    address3: string;
    kana1: string;
    kana2: string;
    kana3: string;
    prefcode: string;
    zipcode: string;
  }[];
}

interface IStored {
  addrea_area: string;
}

function processing(input: IDownload) {
  const item: IStored = {
    addrea_area: "",
  };
  if (input.results.length === 0) return item;
  const target = input.results[0];
  item.addrea_area = target.address1 + target.address2 + target.address3;
  return item;
}

export const usePostcode = () => {
  return useAxios<IUpload, IDownload, IStored>(API_POSTCODE, processing);
};
